<template>
  <div class="job-detail-state-container">
    <div>
      <div class="job-detail-state-progress">
        <p class="job-detail-state-progress-title"><span class="status-point"></span>{{ $t('shu-ju-ding-zheng') }}
          <a @click="handleShowLog(task.dataTaskId)">{{ $t('cha-kan-ri-zhi') }}</a>
        </p>
        <div class="job-detail-state-count">
          <div class="circle-background"></div>
          <i-circle :stroke-width="5" :stroke-color="getCurrentStateColor('REVISE')"
                    :percent="reviseProgress.revisePosDetailObj.percentage" :size="200">
            <span class="detail-Circle-inner"
                  style="font-size:50px">{{ reviseProgress.revisePosDetailObj.percentage }}%</span>
          </i-circle>
          <p style="margin-top: 32px">
            {{ $t('yi-ding-zheng') }}
            <span style="font-weight: 600">
              {{ formatData(reviseProgress.revisePosDetailObj.revisedDiffCount + reviseProgress.revisePosDetailObj.revisedLossCount) }}
            </span>
            {{ $t('hang') }}
          </p>
        </div>
      </div>
      <div class="job-detail-state-detail">
        <p class="job-detail-state-progress-title"><span class="status-point"></span>{{ $t('ding-zheng-xiang-qing') }}</p>
        <div class="job-detail-position">
          <div>
            {{ $t('xiao-yan-wen-jian-lu-jing-reviseprogressreviseposdetailobjcomparersfilepath', [reviseProgress.revisePosDetailObj.compareRsFilePath]) }}
          </div>
          <div>
            {{ $t('xiao-yan-wen-jian-md5-zhi-reviseprogressreviseposdetailobjmd5', [reviseProgress.revisePosDetailObj.md5]) }}
          </div>
          <div>
            {{ $t('xiao-yan-wen-jian-sao-miao-hang-hao-reviseprogressreviseposdetailobjlinenumber', [reviseProgress.revisePosDetailObj.lineNumber]) }}
          </div>
          <div>
            {{ $t('ding-zheng-de-bu-yi-zhi-shu-ju-diffreviseprogressreviseposdetailobjreviseddiffcount', [reviseProgress.revisePosDetailObj.revisedDiffCount]) }}
          </div>
          <div>
            {{ $t('ding-zheng-de-diu-shi-shu-ju-lossreviseprogressreviseposdetailobjrevisedlosscount', [reviseProgress.revisePosDetailObj.revisedLossCount]) }}
          </div>
          <div>
            {{ $t('xu-ding-zheng-zong-hang-shu-reviseprogressreviseposdetailobjtotalreviserows', [reviseProgress.revisePosDetailObj.totalReviseRows]) }}
          </div>
        </div>
      </div>
    </div>
    <div class="job-detail-metric">
      <p class="job-detail-state-progress-title"><span class="status-point"></span>{{ $t('ding-zheng-su-shuai') }}
        <a @click="handleMoreMonitor(taskList['REVISE'].dataTaskId,'REVISE')">{{ $t('geng-duo') }}</a></p>
      <div style="margin-top:20px">
        <div class="panel">
          <div class="panel-header">
            <div style="float: right">
            </div>

            {{ metric.title }}
          </div>
          <div class="panel-body">
            <div style="height: 200px">
              <Metric ref="metric4" :model="metric" :time="time" :resourceType="resourceType"
                      :dataJobId="jobId.toString()"
                      :filters="filters" :selected="metric.selected"
                      :dataTaskId="taskList['REVISE'].dataTaskId.toString()"
                      :filterOthers="filterOthers"></Metric>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { formatCount, formatEnCount } from '../../../util';
import Metric from '../../monitor/metric/metric';

export default {
  components: { Metric },
  props: {
    getCurrentStateColor: Function,
    reviseProgress: Object,
    handleFilterFullTable: Function,
    showFullTransData: Array,
    getProgressStatus: Function,
    taskList: Object,
    fullTotal: Number,
    fullSize: Number,
    handleFullPageChange: Function,
    handleMoreMonitor: Function,
    resourceType: String,
    filters: Object,
    filterOthers: Object,
    metric: Object,
    time: Object,
    jobId: Number,
    filterJobStatus: Array,
    filterTableName: String,
    handleShowLog: Function,
    task: Object
  },
  data() {
    return {
      theFilterJobStatus: this.filterJobStatus,
      theFilterTableName: this.filterTableName,
      formatCount,
      fullTransColumns: [
        {
          title: this.$t('shu-ju-ku'),
          key: 'schema',
          minWidth: 150
        },
        {
          title: this.$t('biao-ming'),
          key: 'table',
          minWidth: 220
        },
        {
          title: ' ',
          slot: 'progress',
          width: 160
        },
        {
          title: ' ',
          slot: 'progress',
          width: 200,
          render: (h, params) => h('div', {}, this.$t('yi-qian-yi-formatcountparamsrowtrans-hang', [this.formatData(params.row.trans)]))
        }
      ]
    };
  },
  methods: {
    formatData(data) {
      if (this.$i18n.locale === 'en-US') {
        return formatEnCount(data);
      }
      return formatCount(data);
    },
    handleRender() {
      const that = this;

      setTimeout(() => {
        if (that.$refs.metric4) {
          that.$refs.metric4.$emit('render');
        }
      }, 100);
    }
  },
  watch: {
    filterJobStatus(val) {
      this.theFilterJobStatus = val;
    },
    filterTableName(val) {
      this.theFilterTableName = val;
    }
  }
};
</script>
